import React, { useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";

import { CustomDialog, DropzoneComponent, CustomCard } from "..";
import { useSelectedTheme } from "../../../Hooks";
import { GetFileTypeIcon } from "../../../Views/Home/NewContactsView/ContactOverview/UI/ContactUploadDocument";
import { formatBytes } from "../../../Helper";

// Styles
import useStyles from "./styles";

// Icons
import { DeleteIcon } from "../../../assets/icons";

function ContactUploadDocumentStep({
  open,
  close,
  translate,
  setNewItems,
  setData,
  index,
  itemValue,
  formType,
  uploadedImageFile,
  setUploadedImageFile,
  uploadedLogoFile,
  setUploadedLogoFile,
  initialState  ,
  onValueChanged ,
  isCompanyOptions,
  isMultiple
}) {
  const styles = useStyles();

  const {
    theme: { palette },
  } = useSelectedTheme();

    const [uploaedFilesAccepted, setUploaedFilesAccepted] = useState([]);
    const [filesAccepted, setFilesAccepted] = useState([]);

  const [uploadedFileId, setUploadedFileId] = useState(null);

  const [currentType, setCurrentType] = useState(null); // "image" or "logo"

  const handleFilesAccepted = (files , selectType) => {
    if(selectType === "image") 
    setFilesAccepted([...filesAccepted , ...files ]);
   else if(selectType === "logo")
    setUploaedFilesAccepted([...uploaedFilesAccepted , ...files ]);

  };

  const formatUploadedDocumentToMapp = () => {
    if (uploadedFileId && currentType) {
      const newImagesFiles =
        currentType === "image"
          ? filesAccepted &&
            filesAccepted.map((f) => ({
              fileId: f,
              fileSize: f.fileSize || f.size,
              fileName: f.path || f.name,
              fileType: f.type,
            }))
          : uploaedFilesAccepted &&
            uploaedFilesAccepted.map((f) => ({
              fileId: f,
              fileSize: f.fileSize || f.size,
              fileName: f.path || f.name,
              fileType: f.type,
            }));

      if (currentType === "image") {
        setUploadedImageFile([...newImagesFiles]);
      } else if (currentType === "logo") {
        setUploadedLogoFile([...newImagesFiles]);
      }
    }
  };


  const handleDeleteUploadedFile = (type, itemFile) => {
    if (type === "image" && itemFile) {
      const newLFilesList = filesAccepted.filter(
        (f) => f?.uuid !== itemFile?.fileId?.uuid
      );
      setUploadedImageFile([
        ...uploadedImageFile.filter(
          (f) => f?.fileId?.uuid !== itemFile?.fileId?.uuid
        ),
      ]);
      setFilesAccepted(newLFilesList);
    } else if (type === "logo" && itemFile) {
      setUploadedLogoFile(
        uploadedLogoFile.filter((f) => f?.fileId?.uuid !== itemFile?.fileId?.uuid)
      );
      setUploaedFilesAccepted(
        uploaedFilesAccepted.filter((f) => f?.uuid !== itemFile?.fileId?.uuid)
      );
    }
  };

  const handleSubmit = () => {
    let  e = {
      selected: [itemValue?.selected],
    };

    if (formType === 2 || isCompanyOptions) {
      if (
        uploadedImageFile &&
        itemValue.selected &&
        itemValue.selected.length > 0 &&
        itemValue.selected.some((i) => i?.lookupItemName === "Company Images")
      ) {
        e["Company Images"] =
          uploadedImageFile &&
          uploadedImageFile.map((i) => ({
            uuid: i?.fileId?.uuid || i?.uuid,
            fileName: i?.fileName,
            url: null,
            fileSize: i?.fileSize || i?.fileId?.fileSize,
            type: "image",
          }));
      }
      if (
        uploadedLogoFile &&
        itemValue.selected &&
        itemValue.selected.length > 0 &&
        itemValue.selected.some((i) => i?.lookupItemName === "Company Logo")
      ) {
        e["Company Logo"] =
          uploadedLogoFile &&
          uploadedLogoFile.map((i) => ({
            uuid: i?.fileId?.uuid || i?.uuid,
            fileName: i?.fileName,
            url: null,
            fileSize: i?.fileSize || i?.fileId?.fileSize,
            type: "logo",
          }));
      }
    } else {
      if (
        uploadedImageFile &&
        itemValue.selected &&
        itemValue.selected.length > 0 &&
        itemValue.selected.some((i) => i?.lookupItemName === "Image Upload")
      ) {
        e["Image Upload"] =
          uploadedImageFile &&
          uploadedImageFile.map((i) => ({
            uuid: i?.fileId?.uuid || i?.uuid,
            fileName: i?.fileName,
            url: null,
            fileSize: i?.fileSize || i?.fileId?.fileSize,
            type: "image",
          }));
      }
    }
    if(onValueChanged){
      onValueChanged({ ...e, selected: itemValue?.selected } , 0 , index) ;
    }
    else if(setNewItems){
    setNewItems(e);
    setData(index, { ...e, selected: itemValue?.selected });
    }

    close();
  };

  useEffect(() => {
    formatUploadedDocumentToMapp();
  }, [uploadedFileId]);


  useEffect(() => {
    if (itemValue && itemValue.selected && itemValue.selected.length > 0) {
      const flatFiles = itemValue.selected.flatMap(
        (item) => itemValue[item.lookupItemName] || []
      );

      let imageList = [];
      let logoList = [];
      flatFiles.map((f) => {
        const file = new File([JSON.stringify(f)], f.fileName, {
          type: "image/jpeg",
          fileName: f.fileName,
          name: f.fileName,
          path: f.fileName,
          uuid: f.uuid,
        });
        file.uuid = f.uuid;
        file.fileId = file;
        file.fileName = f.fileName;
        file.fileType = file.type;
        file.fileSize = f?.fileSize;
        if (f?.type === "image") imageList.push(file);
        else if (f?.type === "logo") logoList.push(file);
        else imageList.push(file);
      });

      setFilesAccepted(imageList);
      setUploaedFilesAccepted(logoList);
      setUploadedImageFile(imageList.length ? imageList : []);
      setUploadedLogoFile(logoList.length ? logoList : []);
    }
  }, [itemValue]);


  return (
    <CustomDialog
      onConfirm={handleSubmit}
      isDisabled={!uploadedImageFile && !uploadedLogoFile}
      open={open}
      onClose={() => {
        let e = {
          selected: [itemValue?.selected],
        };
        if (itemValue && itemValue["Image Upload"])
          e["Image Upload"] = itemValue["Image Upload"];
        if (itemValue && itemValue["Company Logo"])
          e["Company Logo"] = itemValue["Company Logo"];
        if (itemValue && itemValue["Company Images"])
          e["Company Images"] = itemValue["Company Images"];

        if (setNewItems) {
          setNewItems(e);
          setData(index, { ...e, selected: itemValue?.selected });
        } else if (onValueChanged) {
          onValueChanged({ ...e, selected: itemValue?.selected }, 0, index);
        }
        setFilesAccepted(filesAccepted);
        setUploadedImageFile(uploadedImageFile);
        if (currentType === "logo") setUploadedLogoFile(uploadedLogoFile);

        close();
      }}
      width={"688px"}
      title={translate("upload-profile-image-title")}
      subtitle={translate(
        formType === 1
          ? "upload-profile-image-individual-description"
          : "upload-profile-image-company-description"
      )}
      confirmText={translate("Save")}
      content={
        <Box className={styles.containerContentDialog}>
          {itemValue?.selected &&
            itemValue?.selected.length > 0 &&
            itemValue?.selected.some((s) =>
              s.lookupItemName.includes("Image")
            ) && (
              <Box className={styles.containerAttatchmetSection}>
                <Typography className={styles.TitleItem}>
                  {translate("Image")}
                </Typography>
                <Box className={styles.uploadedSection}>
                  <DropzoneComponent
                    accept={"image/*"}
                    title={translate("SVG-PNG-JPG-or-GIF-max-800x400px")}
                    onFilesAccepted={(files) => {
                      setCurrentType("image");
                      handleFilesAccepted(files, "image");
                    }}
                    setUploadedFileId={setUploadedFileId}
                    initialState={initialState}
                    isMultiple={isMultiple}
                    setUploadedFileIds={setUploadedFileId}
                  />
                  {uploadedImageFile &&
                    uploadedImageFile.length > 0 &&
                    uploadedImageFile.map((itemFile, indexFile) => (
                      <Box
                        className={styles.containerUpladedFilesCrads}
                        key={indexFile}
                      >
                        <CustomCard
                          boxShadow="xs"
                          borderRadius="xl"
                          borderColor="secondary"
                          classes={styles.CardUploadedFilesInfo}
                        >
                          {GetFileTypeIcon(itemFile?.fileType)}
                          <Box className={styles.ContainerFileUploadedInfo}>
                            <Box className={styles.containerTitleAndDeleteIcon}>
                              <Typography className={styles.TitleFileName}>
                                {itemFile?.fileName}
                              </Typography>
                              <DeleteIcon
                                width="20"
                                height="20"
                                className={styles.DeleteIcon}
                                style={{ cursor: "pointer" }}
                                fill={palette.button.secondary_fg}
                                onClick={() =>
                                  handleDeleteUploadedFile("image", itemFile)
                                }
                              />
                            </Box>
                            <Typography className={styles.FileSizeTitle}>
                              {formatBytes(itemFile?.fileSize)}
                            </Typography>
                          </Box>
                        </CustomCard>
                      </Box>
                    ))}
                </Box>
              </Box>
            )}
          {/* Logo Upload Section */}

          {(formType === 2 || isCompanyOptions) &&
            itemValue?.selected.some((s) =>
              s.lookupItemName.includes("Logo")
            ) && (
              <Box className={styles.containerAttatchmetSection}>
                <Typography className={styles.TitleItem}>
                  {translate("Logo")}
                </Typography>

                <Box className={styles.uploadedSection}>
                  <DropzoneComponent
                    accept={"image/*"}
                    title={translate("SVG-PNG-JPG-or-GIF-max-800x400px")}
                    onFilesAccepted={(files) => {
                      setCurrentType("logo");
                      handleFilesAccepted(files, "logo");
                    }}
                    setUploadedFileId={setUploadedFileId}
                    isMultiple={isMultiple}
                    setUploadedFileIds={setUploadedFileId}
                  />
                  {uploadedLogoFile &&
                    uploadedLogoFile.length > 0 &&
                    uploadedLogoFile.map((itemFile, index) => (
                      <Box
                        className={styles.containerUpladedFilesCrads}
                        key={index}
                      >
                        <CustomCard
                          boxShadow="xs"
                          borderRadius="xl"
                          borderColor="secondary"
                          classes={styles.CardUploadedFilesInfo}
                        >
                          {GetFileTypeIcon(itemFile?.fileType)}
                          <Box className={styles.ContainerFileUploadedInfo}>
                            <Box className={styles.containerTitleAndDeleteIcon}>
                              <Typography className={styles.TitleFileName}>
                                {itemFile?.fileName}
                              </Typography>
                              <DeleteIcon
                                width="20"
                                height="20"
                                className={styles.DeleteIcon}
                                style={{ cursor: "pointer" }}
                                fill={palette.button.secondary_fg}
                                onClick={() =>
                                  handleDeleteUploadedFile("logo", itemFile)
                                }
                              />
                            </Box>
                            <Typography className={styles.FileSizeTitle}>
                              {formatBytes(itemFile?.fileSize)}
                            </Typography>
                          </Box>
                        </CustomCard>
                      </Box>
                    ))}
                </Box>
              </Box>
            )}
        </Box>
      }
    />
  );
}

export default ContactUploadDocumentStep;
